
import React from 'react';
import Modal from 'react-modal';

import Header from './components/Header';
import Hero from './components/Hero';
import CrisisOverview from './components/CrisisOverview';
import ResearchFoundation from './components/ResearchFoundation';
import FeatureHighlights from './components/FeatureHighlights';

import LiveDemo from './components/LiveDemo';

import CompetitiveAdvantages from './components/CompetitiveAdvantages';

import Impact from './components/Impact';
import Footer from './components/Footer';


// Set the app element for react-modal
Modal.setAppElement('#root');

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <CrisisOverview />
        <ResearchFoundation />
        <FeatureHighlights />
        <LiveDemo />
        <CompetitiveAdvantages />
        <Impact />
        <Footer />
      </main>
    </div>
  );
}

export default App;